import { render } from "./AddDocument.vue?vue&type=template&id=68966908&scoped=true&ts=true"
import script from "./AddDocument.vue?vue&type=script&lang=ts"
export * from "./AddDocument.vue?vue&type=script&lang=ts"

import "./AddDocument.vue?vue&type=style&index=0&id=68966908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68966908"]])

export default __exports__